import './ui.css';
interface Props { label: string; color?: string; }
export function StatusBadge({ label, color = 'var(--text-muted)' }: Props) {
  return (
    <span className="status-badge" style={{ '--badge-color': color } as React.CSSProperties}>
      <span className="status-badge__dot" />
      {label}
    </span>
  );
}
